import React from "react";
import { useTheme } from "styled-components";

import { Icon, style } from "./Symbolicons";

const ListMedicalCross = (props: Icon): React.ReactElement => {
  const theme = useTheme();

  return (
    <svg
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{ ...style(props.size, props.height), ...props.style }}
      className={props.className}
    >
      <path
        d="M9.333 5.333H6.667A2.667 2.667 0 0 0 4 8v17.333A2.667 2.667 0 0 0 6.667 28H16"
        stroke={props.color || theme.palette.grey600}
        strokeWidth={1.25}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <rect
        x={9.333}
        y={2.667}
        width={10.667}
        height={5.333}
        rx={1}
        stroke={props.color || theme.palette.grey600}
        strokeWidth={1.25}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M20 5.333h2.667A2.667 2.667 0 0 1 25.333 8v4M9.333 13.167a.167.167 0 1 0 0 .333.167.167 0 0 0 0-.333M9.333 18.5a.167.167 0 1 0 0 .333.167.167 0 0 0 0-.333M19.333 13.333h-6M14.667 18.667h-1.334"
        stroke={props.color || theme.palette.grey600}
        strokeWidth={1.25}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        clipRule="evenodd"
        d="M29.333 21.6c0-.59-.477-1.067-1.066-1.067h-2.134V18.4c0-.59-.477-1.067-1.066-1.067h-2.134c-.589 0-1.066.478-1.066 1.067v2.133h-2.134c-.589 0-1.066.478-1.066 1.067v2.133c0 .59.477 1.067 1.066 1.067h2.134v2.133c0 .59.477 1.067 1.066 1.067h2.134c.589 0 1.066-.478 1.066-1.067V24.8h2.134c.589 0 1.066-.478 1.066-1.067V21.6Z"
        stroke={props.color || theme.palette.grey600}
        strokeWidth={1.25}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export { ListMedicalCross };
